import { ContentSwitcherByState } from 'components/Atoms/ContentSwitcherByState'
import { SingleContentToggle } from 'components/Atoms/SingleContentToggle'
// import { WalletSelector } from 'components/Molecules/WalletSelector'
import { useState } from 'react'
import { ForgotPasswordForm } from './ForgotPasswordForm'
// import { ForgotPasswordForm } from './ForgotPasswordForm'
import { SignInForm } from './SignInForm'
// import { SignUpForm } from './SignUpForm'

const doNothing = () => null

export const Tabs = ({ closeModal, type = 'signIn', promotionalCode, openSignUpModal }) => {
  const [tabId, setTabId] = useState('signIn')
  const onTabClick = (tabId) => {
    setTabId(tabId)
  }
  return (
    <>
      <ContentSwitcherByState
        noWrapper
        activeState={tabId}
        stateObject={{
          signIn: (
            <>
              <h1>Sign In</h1>
              <h2>Use your YOLOREKT account to sign in.</h2>
            </>
          ),
          frgtPsw: <></>,
        }}
      />

      <div className='signin_modal_tabs_wrapper'>
        <input
          className='radio'
          id='signin_one'
          name='signin_group'
          type='radio'
          checked={tabId === 'signIn'}
          onChange={doNothing}
        />
        <input
          className='radio'
          id='hidden_pr'
          name='signin_group'
          type='radio'
          checked={tabId === 'frgtPsw'}
          onChange={doNothing}
        />
        <ContentSwitcherByState
          className='panels'
          activeState={tabId}
          stateObject={{
            signIn: <SignInForm onFrgtPsw={() => setTabId('frgtPsw')} openSignUpModal={openSignUpModal} />,
            frgtPsw: <ForgotPasswordForm onReturn={() => setTabId('signIn')} />,
          }}
        />
      </div>
    </>
  )
}
